import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    VisuallyHidden,
    useMultiStyleConfig,
} from '@chakra-ui/react'
import {defineMessages, useIntl} from 'react-intl'
import {CloseIcon} from '../../icons'
import GalleryBody from './gallery-body'

const messages = defineMessages({
    closeGallery: {
        id: 'gallery-modal.close',
        defaultMessage: 'Close image gallery',
    },
    modalTitle: {
        id: 'gallery-modal.title',
        defaultMessage: 'Product image gallery',
    },
})

const GalleryModal = ({
    imageGroups = [],
    selectedVariationAttributes = {},
    isOpen,
    lazy = false,
    closeModal,
    openModal,
    videoUrl,
    isModalGallerySwiper,
    setIsModalGallerySwiper,
    modalInitValue,
    powerImages = [],
    initialSelectedIndex = 0,
    onBoundaryNavigate,
}) => {
    const intl = useIntl()
    const styles = useMultiStyleConfig('GalleryModal')
    return (
        // Scroll is already locked via the 'img-gallery-modal-open' html class (see index.jsx),
        // so Chakra's own lock is disabled to avoid its scrollbar-compensation shrinking the modal width.
        <Modal isOpen={isOpen} onClose={closeModal} size="full" blockScrollOnMount={false}>
            <ModalOverlay />
            <ModalContent
                aria-labelledby="gallery-modal-title"
                data-ab="gallery-exploded"
                data-cs-label="gallery-exploded"
                {...styles.galleryModalContent}
            >
                <VisuallyHidden id="gallery-modal-title">
                    {intl.formatMessage(messages.modalTitle)}
                </VisuallyHidden>
                <Box {...styles.galleryModalHeaderContent}>
                    <Box
                        as="button"
                        type="button"
                        data-testid="close-modal-button"
                        onClick={closeModal}
                        aria-label={intl.formatMessage(messages.closeGallery)}
                        {...styles.galleryModalCloseIcon}
                    >
                        <CloseIcon aria-hidden="true" />
                    </Box>
                </Box>
                <ModalBody {...styles.galleryModalBody}>
                    <GalleryBody
                        imageGroups={imageGroups}
                        selectedVariationAttributes={selectedVariationAttributes}
                        lazy={lazy}
                        openModal={openModal}
                        variant="inModal"
                        isModalOpen={isOpen}
                        videoUrl={videoUrl}
                        isModalGallerySwiper={isModalGallerySwiper}
                        setIsModalGallerySwiper={setIsModalGallerySwiper}
                        modalInitValue={modalInitValue}
                        powerImages={powerImages}
                        initialSelectedIndex={initialSelectedIndex}
                        onBoundaryNavigate={onBoundaryNavigate}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

GalleryModal.propTypes = {
    imageGroups: PropTypes.array,
    isOpen: PropTypes.bool,
    lazy: PropTypes.bool,
    closeModal: PropTypes.func,
    openModal: PropTypes.func,
    selectedVariationAttributes: PropTypes.object,
    videoUrl: PropTypes.string,
    styles: PropTypes.object,
    isModalGallerySwiper: PropTypes.bool,
    setIsModalGallerySwiper: PropTypes.func,
    modalInitValue: PropTypes.number,
    powerImages: PropTypes.array,
    initialSelectedIndex: PropTypes.number,
    onBoundaryNavigate: PropTypes.func,
}

export default GalleryModal
